import { Locale } from '@lts-web/data-objects';

export const ENGLISH = new Locale('en', { name: 'en' });
export const HEBREW = new Locale('he', { name: 'iw_il' });
export const US = new Locale('en-US', { name: 'en', region: 'US' });
export const ISRAEL = new Locale('he-IL', { name: 'iw_il', region: 'IL' });